"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.tab.posts': 'Posts',
    'socialMediaPlan.tab.calendar': 'Schedule',
    'socialMediaPlan.tab.history': 'Activity',
};
